var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimerGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D5D5D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patient Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient Profile_2",
    clipPath: "url(#clip0_314_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 990,
    transform: "translate(-1197 -749)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 24621",
    filter: "url(#filter0_d_314_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -249,
    y: -197,
    width: 468,
    height: 326,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Detail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bagde"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-delivery-time 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 1.66602C5.40706 1.66602 1.6665 5.40657 1.6665 9.99935C1.6665 14.5921 5.40706 18.3327 9.99984 18.3327C11.6978 18.3327 13.2784 17.8165 14.5978 16.9411L15.8478 18.1911C16.1495 18.4936 16.6665 18.28 16.6665 17.8525V14.8512C16.6665 14.4729 16.3596 14.166 15.9813 14.166H12.98C12.5525 14.166 12.3398 14.683 12.6414 14.9847L13.3918 15.735C12.3984 16.3242 11.2424 16.666 9.99984 16.666C6.30762 16.666 3.33317 13.6916 3.33317 9.99935C3.33317 6.30713 6.30762 3.33268 9.99984 3.33268C13.441 3.33268 16.2576 5.9228 16.6258 9.25716C16.65 9.47688 16.7605 9.678 16.9329 9.81627C17.1054 9.95454 17.3257 10.0186 17.5454 9.99447C17.7651 9.97029 17.9662 9.85983 18.1045 9.68737C18.2428 9.51491 18.3069 9.29459 18.2827 9.07487C17.8226 4.90923 14.2804 1.66602 9.99984 1.66602ZM9.98682 4.98796C9.76609 4.99141 9.55574 5.08229 9.40195 5.24066C9.24816 5.39903 9.16348 5.61195 9.1665 5.83268V9.99935C9.16653 10.2204 9.25433 10.4323 9.41061 10.5886C9.56688 10.7449 9.77883 10.8327 9.99984 10.8327H12.4998C12.6103 10.8342 12.7199 10.8138 12.8224 10.7727C12.9248 10.7315 13.0181 10.6704 13.0968 10.5928C13.1754 10.5153 13.2378 10.4229 13.2805 10.321C13.3231 10.2191 13.345 10.1098 13.345 9.99935C13.345 9.88891 13.3231 9.77958 13.2805 9.67769C13.2378 9.57581 13.1754 9.48342 13.0968 9.40588C13.0181 9.32835 12.9248 9.26721 12.8224 9.22603C12.7199 9.18485 12.6103 9.16445 12.4998 9.16602H10.8332V5.83268C10.8347 5.72119 10.8138 5.61053 10.7718 5.50724C10.7298 5.40396 10.6675 5.31016 10.5886 5.23139C10.5097 5.15262 10.4157 5.09049 10.3124 5.04868C10.209 5.00686 10.0983 4.98621 9.98682 4.98796Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: -4068,
    y: -2160,
    width: 30445,
    height: 12277,
    stroke: "black",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_314_387",
    x: -279,
    y: -224,
    width: 528,
    height: 386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0588235 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 990,
    fill: "white",
    transform: "translate(-1197 -749)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimerGray);
export default __webpack_public_path__ + "static/media/iconTimerGray.0d82024f58433cfd67059623329b1fff.svg";
export { ForwardRef as ReactComponent };